/*
  Measures how much sits above the hero (countdown bar, announcement bar,
  header, whatever the merchant stacks up there) and exposes it as
  --hero-offset-top so the "full screen" height can subtract it.

  Without this, a 100svh hero is pushed down by the header and its bottom
  falls below the fold, which throws the composition off centre on phones.
  If this script never runs the variable stays at 0 and the hero is a plain
  100svh, so nothing breaks.
*/
class FullScreenHero extends HTMLElement {
  connectedCallback() {
    this.update = this.update.bind(this);
    this.update();

    window.addEventListener('resize', this.update);
    window.addEventListener('load', this.update);

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.update);
      if (this.previousElementSibling) this.observer.observe(this.previousElementSibling);
      if (this.parentElement) this.observer.observe(this.parentElement);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.update);
    window.removeEventListener('load', this.update);
    if (this.observer) this.observer.disconnect();
  }

  update() {
    var offset = this.getBoundingClientRect().top + window.scrollY;
    // Anything past half the screen means the hero is not at the top of the
    // page, and subtracting that much would collapse it.
    if (offset > window.innerHeight / 2) offset = 0;
    this.style.setProperty('--hero-offset-top', Math.max(0, Math.round(offset)) + 'px');
  }
}

if (!customElements.get('full-screen-hero')) {
  customElements.define('full-screen-hero', FullScreenHero);
}
